// extracted by mini-css-extract-plugin
export default {"dashboardButton":"GoToDashboardButton_dashboardButton__hz+kR","dashboardIcon":"GoToDashboardButton_dashboardIcon__tOjfL"};